import authApi from "../../utils/AxiosConfig"
import authHeader from "../../utils/authHeader"

const API_URL = '/products';

// Get all products
const getAllProducts = async (token) => {
    const response = await authApi.get(API_URL, {
        headers: authHeader(token),
    });
    return response.data;
};

// Get a single product by ID
const getProductById = async (id, token) => {
    const response = await authApi.get(`${API_URL}/${id}`, {
        headers: authHeader(token),
    });
    return response.data;
};

// Fetch product by slug
const getProductBySlug = async (slug) => {
    const response = await authApi.get(`${API_URL}/${slug}`);
    return response.data;
};

// Create a new product
const createProduct = async (productData, token) => {
    const response = await authApi.post(API_URL, productData, {
        headers: authHeader(token),
    });
    return response.data;
};

// Update a product
const updateProduct = async (id, productData, token) => {
    const response = await authApi.put(`${API_URL}/${id}`, productData, {
        headers: authHeader(token),
    });
    return response.data;
};

// Delete a product
const deleteProduct = async (id, token) => {
    const response = await authApi.delete(`${API_URL}/${id}`, {
        headers: authHeader(token),
    });
    return response.data;
};

const productService = {
    getAllProducts,
    getProductById,
    createProduct,
    updateProduct,
    deleteProduct,
    getProductBySlug,
};

export default productService;
